'use strict';

import moment from 'moment';
import { module } from '../app';
import * as _ from 'lodash';
import pubsubService from '../services/pubsub.service';
import { constantStrings } from '../constants/constantStrings';
import * as worklistConstants from '../constants/worklist-constants';
import * as stateConstants from '../constants/state-constants';
import * as commonConstants from "../constants/constantStrings";

module
  .factory('worklistViewModel', [
    '$location', 'Worklist', 'authService', 'localStorage', '$rootScope', '$ionicLoading', 'modalService', 'eventsMgr', 'Study', 'linkStudiesViewModel',
    'techpadConfig', 'dataRetrieverService', 'signalrService', '$state', 'statusHelpers', 'enums', 'errorSyncService',
    'techpadOptions',
    'WorklistFilterSettings',
    'WorklistFilterViewModel',
    '$timeout', '$http', '$window', 'tpConfig', 'environmentHelper',
    'dateFormattingHelper', 'serverTimeService',
    function ($location, Worklist, authService, localStorage, $rootScope, $ionicLoading, modalService, eventsMgr, Study, linkStudiesViewModel,
              techpadConfig, dataRetrieverService, signalrService, $state, statusHelpers, enums, errorSyncService,
              techpadOptions,
              WorklistFilterSettings,
              WorklistFilterViewModel,
              $timeout, $http, $window, tpConfig, environmentHelper, dateFormattingHelper, serverTimeService) {
      let vm = function (state, $scope) {

        let self = this;

        self.pageTitle = worklistConstants.DEFAULT_WORKLIST_PAGE_TITLE;
        self.enableSearchButton = worklistConstants.DEFAULT_ENABLE_SEARCH_BUTTON;
        self.enableFilterButton = worklistConstants.DEFAULT_ENABLE_FILTER_BUTTON;
        self.enableOutsideStudiesOption = worklistConstants.DEFAULT_ENABLE_OUTSIDE_STUDIES_OPTION;
        self.enableLinkExamsOption = $rootScope.techpadSettings.IsLinkExamEnabled;
        self.isMyPatients = worklistConstants.DEFAULT_IS_MY_PATIENTS;

        self.shouldShowTags = worklistConstants.DEFAULT_SHOULD_SHOW_TAGS;

        if (state) {
          self.pageTitle = state.pageTitle !== undefined ? state.pageTitle : self.pageTitle;
          self.enableSearchButton = state.enableSearchButton !== undefined ? state.enableSearchButton === true : self.enableSearchButton;
          self.enableFilterButton = state.enableFilterButton !== undefined ? state.enableFilterButton === true : self.enableFilterButton;
          self.enableOutsideStudiesOption = state.enableOutsideStudiesOption !== undefined ? state.enableOutsideStudiesOption === true : self.enableOutsideStudiesOption;
          self.isMyPatients = state.isMyPatients !== undefined ? state.isMyPatients === true : self.isMyPatients;

          self.shouldShowTags = state.shouldShowTags !== undefined ? state.shouldShowTags === true : self.shouldShowTags;
        }

        self.authService = authService;

        self.getPermissions = function () {
          let permissions = $rootScope.authService.getPermissions();
          let permissionsJson;

          if (!permissions) {
            permissionsJson = {};
          } else {
            permissionsJson = JSON.parse($rootScope.authService.getPermissions());  
          }

          return permissionsJson;
        }

        self.worklistConstants = worklistConstants;

        $rootScope.pinNumbers = [];

        let currentIndexHasData = 0;

        self.isIOSDevice = environmentHelper.isIOSDevice();
        
        self.constantStrings = constantStrings;
        
        self.techpadConfig = techpadConfig;

        self.statusHelpers = statusHelpers;
        
        self.statuses = enums.statuses;
        
        self.__created = new Date().getTime();

        self.userPermissions = self.getPermissions();

        self.worklistStatuses = enums.worklistStatuses;

        self.additionalInfos = enums.worklistAdditionalInfos;

        self.stopInfiniteLoad = true;

        self.examShortCodeTypes = enums.examShortCodeTypes;

        self.examTypes = enums.examTypes;
        Worklist.getExamTypes().then(function(resp){
          self.examTypes = _.map(resp.data, 'Value');
        });

        self.visitTypes = enums.visitTypes;
        self.allStatusGroups = enums.allStatusGroups;
        self.getStatusName = statusHelpers.getStatusName;
        self.getColor = statusHelpers.getColor;
        self.GetImHereStatusMessage = statusHelpers.GetImHereStatusMessage;
        self.GetImHereStatusIconClass = statusHelpers.GetImHereStatusIconClass;
        self.GetImHereStatusMessageClass = statusHelpers.GetImHereStatusMessageClass;
        self.getIcon = statusHelpers.getIcon;

        self.isOnline = () => $rootScope.isOnline();

        techpadOptions.getOptions();
        self.darkMode = techpadOptions.options.DarkMode;
        self.displayTotalTimePatientHasBeen = techpadOptions.options.DisplayTotalTimePatientHasBeen;
        self.ListMessageReadOnly = techpadOptions.options.ListMessageReadOnly;
        self.hideComments = techpadOptions.options.HideComments || false;


        self.ShowAppointmentTimeOnWorklist = function(AppointmentTime){
          return self.techpadConfig.settings.ShowAppointmentTime && self.techpadConfig.settings.IsAnySchorderRecordExist && AppointmentTime
        }

        self.getWorklistRowClass = function(item) {
          return self.ShowAppointmentTimeOnWorklist(item.AppointmentTime) ? 'worklistItemWithAppointmentTime' : '';
        }

        self.onTechpadSettingChanged = function (newSettings) {
          self.techpadConfig.settings = newSettings;
        };

        let techpadConfigChangeRegistration = techpadConfig.registerOnSettingChange(self.onTechpadSettingChanged);

        self.getAllowedStatusGroups = function () {
          let userRoles = authService.getRoles();
          return _.filter(self.allStatusGroups, function (group) {
            return !group.onlyForRoles || _.find(group.onlyForRoles, function (role) {
              return userRoles.indexOf(role) != -1;
            });
          });
        };

        self.shouldDisableRefreshBtn = function () {
          // disable refresh if not online
          let isOnline = self.isOnline(); 

          return !isOnline;
        };

        self.onNetworkAvailabilityChanged = function (scope, data) {
          if (self.isOnline()) {
            if (!self.initialized) {
              self.loadFiltersAndWorklistData();
            } else {
              self.refresh();
            }
          }
        };

        let selectedLocations = [];
        let selectedStatuses = [];
        let selectedExamTypes = [];
        let selectedExamTypesInGroups = [];
        let selectedExamShortCodeTypes = [];
        let selectedVTypes = [];
        let selectedTags = [];

        self.filterObj = {};

        self.convertAppointmentDatesToClientTime = function (item) {
          if(!self.ShowAppointmentTimeOnWorklist(item.AppointmentTime)){
            return
          }

          var appDate = new Date(item.AppointmentDateTime);

          var timezoneOffset = moment(new Date()).utcOffset();

          var LocalDate = new Date(appDate.getTime() + appDate.getTimezoneOffset() * 60 * 1000);

          item.AppointmentDateTime = moment(LocalDate).add(timezoneOffset, 'm').toDate();
          item.AppointmentTime = moment(item.AppointmentDateTime).format("hh:mm A");
        }

        self.itemUpdated = function (item) {
          //TPAD-355: Only display finished exams on my patients.
          if (self.isMyPatients && item.Status != self.worklistStatuses.Finished) {
            self.itemRemoved(item);
            return;
          }

          // ignore Finished worklist item if not showing all or not my patients
          if (item.Status == self.worklistStatuses.Finished && (!(self.filters && self.filters.ShowAllExams) && !self.isMyPatients)) {
            self.itemRemoved(item);
            return;
          }

          let updatedItem = _.find(self.allItems, function (i) {
            return i.Id == item.Id;
          });

          self.convertAppointmentDatesToClientTime(item);
          if (!!updatedItem) {
            _.merge(updatedItem, item);
          } else {
            self.itemCreated(item);
          }
          self.allItems = self.filter(self.allItems);
          self.allItems = self.sort(self.allItems);
        };

        self.itemCreated = function (item) {
          $rootScope.$apply(function () {
            if (!self.allItems) {
              self.allItems = [];
            }

            //TPAD-355: Only display finished exams on my patients.
            if (self.isMyPatients && item.Status != self.worklistStatuses.Finished) {
              return;
            }

            // ignore Finished worklist item if not showing all or not my patients
            if (item.Status == self.worklistStatuses.Finished && (!(self.filters && self.filters.ShowAllExams) && !self.isMyPatients)) {
              return;
            }

            self.allItems.splice(0, 0, item);
            self.allItems = self.filter(self.allItems);
            self.allItems = self.sort(self.allItems);
            self.convertAppointmentDatesToClientTime(item);
          });
        };

        self.itemRemoved = function (item) {
          $rootScope.$apply(function () {
            if (self.allItems && self.allItems.length)
              self.allItems = _.filter(self.allItems, function (x) {
                return item.Id.toString() != x.Id.toString();
              });
          });
        };

        self.isLoadingMore = false;
        self.loadMore = function ($event) {
          $scope.$broadcast('scroll.infiniteScrollComplete');
          if (self.isLoadingMore)
            return;

          //self.isLoadingMore = true;
          $timeout(function () {
            self.filterObj.pageIndex++;
            self.refresh();
          }, 200);
        };

        self.refresh = async function (isSyncWithMagview) {
          if (self.filterObj.pageIndex == 0) {
            $ionicLoading.show({
              template: 'Loading...'
            });
          }

          self.isLoadingMore = true;

          // Assign the filter on server side to prevent client filtering
          let filterObj = _.cloneDeep(self.filterObj);
          filterObj.selectedLocations = selectedLocations;
          filterObj.selectedExamTypes = selectedExamTypes.length !== enums.examTypes.length ? _.uniq(selectedExamTypes.concat(selectedExamShortCodeTypes)) : [];
          filterObj.selectedStatuses = selectedStatuses.length !== enums.statuses.length ? selectedStatuses : [];
          filterObj.selectedVisitTypes = selectedVTypes.length !== enums.visitTypes.length ? selectedVTypes : [];

          filterObj.ShowAllTags = self.filters.ShowAllTags;
          filterObj.ShowNoTags = self.filters.ShowNoTags;
          filterObj.selectedTags = filterObj.ShowAllTags ? techpadConfig.settings.Tags.map((tag) => {return tag.Label;}) : selectedTags;
          filterObj.selectedSortingOptions = self.filters.SortingOptions;
          
          try {
            const resp = await dataRetrieverService.cachedProxy('worklist-items-' + self.filterObj.pageIndex, 0, function () {
              return Worklist.getAll(filterObj, isSyncWithMagview);
            });

            if (self.filterObj.pageIndex === 0) {
              $ionicLoading.hide();
            }
            //Eugene: sometimes had an issue with removing worklist when the object self.allItems is not empty on this line
            //this causes an issue with showing on the UI of the already removed worklist
            //so I'm trying to clear the existing worklistList object to prevent current issue
            if(self.allItems && self.allItems.length && resp.data.length > 0 && self.filterObj.pageIndex === 0){
              self.allItems = [];
            }
            
            self.stopInfiniteLoad = resp.data.length < 10;

            if (resp.data.length === 0) {
              self.filterObj.pageIndex = currentIndexHasData;
            } else {
              currentIndexHasData = self.filterObj.pageIndex;
            }

            self.allItems = (self.allItems || []).concat(resp.data);

            if (resp._offlineVersion) {
              await modalService.showAlert('Offline version of data is loaded. This data may not be actual.', undefined, 'offline-data-loaded-message');
            }

            self.allItems.forEach(item => self.convertAppointmentDatesToClientTime(item));
            
            try {
              self.allItems = self.filter(self.allItems);
              const { IsDashboardMode } = self.techpadConfig.settings;
              if (IsDashboardMode) {
                self.allItems = self.sort(self.allItems);
              }
            } catch (err) {
              let errorData = {
                ExceptionMessage: 'Client-side exception: ' + err.message,
                StackTrace: err.stack
              };
              modalService.showErrorMessage(errorData, 0);

              errorSyncService.logError({
                status: 0,
                data: errorData
              });
            }
          } catch (resp) {
            $ionicLoading.hide();
            if (resp.status === 409) {
              modalService.showAlert(resp.data, self.refreshPage);
            } else {
              modalService.showErrorMessage(resp.data, resp.status);
            }
          } finally {
            $scope.$broadcast('scroll.infiniteScrollComplete');
            $scope.$broadcast('scroll.refreshComplete');
            $timeout(() => {
              self.isLoadingMore = false;
              $ionicLoading.hide();
            }, 300);
          }
        };

        self.refreshPage = function () {
          $window.location.reload();
        };

        self.search = function () {
          self.filterObj.pageIndex = 0;
          self.allItems = [];
          self.refresh();
        };

        self.searchOnKeyPress = function (keyEvent) {
          if (keyEvent.which === 13) {
            self.search();
          }
        };

        self.hardRefresh = function (isSyncWithMagview) {
          self.filterObj.pageIndex = 0;
          self.allItems = [];
          self.refresh(isSyncWithMagview);
        };

        self.filter = function (items) {

          if (!items || !items.length) {
            return [];
          }

          if (self.filters && self.filters.ShowAllExams) {
            return items;
          }

          // Technologist filter - need in case of signalR update
          let name = (authService.getUserName() || '').toLowerCase();

          if (self.isMyPatients || self.filters.ShowMyExamsOnly) {
            items = items.filter(function (i) {
              return !!i.Technologist && i.Technologist.Email.toLowerCase() == name;
            });
          }

          let isAllLocations = self.filters.Locations && self.filters.Locations.All;

          if (self.filters.Locations && !isAllLocations) {

            if (selectedLocations.length) {
              items = items.filter(function (i) {
                return _.includes(selectedLocations, i.Location);
              });
            }
          }

          let isAllExamTypes = self.filters.ExamTypes && self.filters.ExamTypes.some(_ => _ === 'All');
          if (self.filters.ExamTypes && !isAllExamTypes) {
            if(selectedExamTypes && selectedExamTypes.length){
              items = items.filter(function (i) {
                return (self.filterByType(selectedExamTypes, i.Type) || self.filterByType(selectedExamShortCodeTypes, i.Type)
                        || $rootScope.techpadSettings.GroupExamTypeWorklistFilter && self.filterByType(self.selectedExamTypesInGroups, i.Type))
              });
            }
          }

          let filtered = items;
          if(!self.isMyPatients){
            filtered = items.filter(function (i) {
              return _.includes(selectedStatuses, i.Status) &&
                _.includes(selectedVTypes, ((i.VisitType || '').trim() || 'S'));
            });
          }

          if(selectedTags && !self.filters.ShowAllTags && selectedTags.length != 0){ 
            const selectedTagsValues = techpadConfig.settings.Tags.filter(tagConfig => selectedTags.some(tag => tag === tagConfig.Label)).map(x => x.Value);           
            filtered = filtered.filter(function (i) {
              const itemTags = i.Tags.split(';');
              var shouldIncludeItemWithNoTags = (i.Tags === "" && self.filters.ShowNoTags)
              return shouldIncludeItemWithNoTags ? true : itemTags.some(tag => _.includes(selectedTagsValues, tag)); 
            });
          }

          return filtered;
        };

        self.sort = function (items) {
          const { IsDashboardMode } = self.techpadConfig.settings;
          if (IsDashboardMode) {
            return _.orderBy(_.uniqBy(items, 'Id'), [function (item) {
              return item.Status === self.worklistStatuses.ReviewComplete;
            }, 'ModifiedDate'], ['desc', 'desc']);
          } else {
            var SortingOptions = self.filters.SortingOptions;

            var shouldSortByDefault = !self.techpadConfig.settings.ShowAppointmentTime || SortingOptions == null || SortingOptions.includes(constantStrings.DefaultSortOption);

            if (shouldSortByDefault)
            {
              return _.orderBy(_.uniqBy(items, 'Id'), ['Priority', 'StartTime']);
            }
            else
            {
              var shouldSortByAppointmentTimeDesc = SortingOptions.includes(constantStrings.AppoinmentSortOptionDesc);

              var shouldSortByAppointmentTimeAsc = SortingOptions.includes(constantStrings.AppoinmentSortOptionAsc);

              var shouldSortByStudyDateDesc = SortingOptions.includes(constantStrings.StudyDateSortOptionDesc);

              var shouldSortByStudyDateAsc = SortingOptions.includes(constantStrings.StudyDateSortOptionAsc);

              if (shouldSortByStudyDateDesc)
              {
                return _.orderBy(_.uniqBy(items, 'Id'), [( o ) => { return new Date(o.StudyDate === constantStrings.DateTimeNullValue ? constantStrings.DateMinValue : o.StudyDate)}, ( o ) => { return o.Priority || ''}, ( o ) => { return o.StartTime || ''}], ['desc', 'asc', 'asc']);
              }

              if (shouldSortByStudyDateAsc)
              {
                return _.orderBy(_.uniqBy(items, 'Id'), [( o ) => { return new Date(o.StudyDate === constantStrings.DateTimeNullValue ? constantStrings.DateMaxValue : o.StudyDate)}, ( o ) => { return o.Priority || ''}, ( o ) => { return o.StartTime || ''}], ['asc', 'asc', 'asc']);
              }

              if (shouldSortByAppointmentTimeDesc)
              {
                return _.orderBy(_.uniqBy(items, 'Id'), [( o ) => { return new Date(o.AppointmentDateTime === constantStrings.DateTimeNullValue ? constantStrings.DateMinValue : o.AppointmentDateTime)}, ( o ) => { return o.Priority || ''}, ( o ) => { return o.StartTime || ''}], ['desc', 'asc', 'asc']);
              }

              if (shouldSortByAppointmentTimeAsc)
              {
                return _.orderBy(_.uniqBy(items, 'Id'), [( o ) => { return new Date(o.AppointmentDateTime === constantStrings.DateTimeNullValue ? constantStrings.DateMaxValue : o.AppointmentDateTime)}, ( o ) => { return o.Priority || ''}, ( o ) => { return o.StartTime || ''}], ['asc', 'asc', 'asc']);
              }
            }
          }
        }

        self.filterByType = function (selectedTypes, typeStr) {

          if (!typeStr) {
            return selectedTypes.indexOf('Other') >= 0;
          }

          let types = typeStr.split(', ');
          let hasOneFromSelected = selectedTypes.some(selectedType => types.some(type => type.includes(selectedType)));
          return hasOneFromSelected;
        };

        self.canOpenItem = function (item, viewOnly) {
          let allowedStatuses = [
            'SurveyFinished', 'ExamWaiting', 'ExamIncomplete', 'ExamInProgress', 'ExamPaused', 'ExamStopped', 'UltrasoundRequested', 'RISWaiting',
            'New', 'SurveyStarted'
          ];

          if(item.IsMissingPatient){
            return false;
          }

          if (viewOnly) {
            return true;
          }

          if (allowedStatuses.indexOf(item.Status) < 0) {
            return false;
          }

          return true;
        };

        self.unlockExamPrompt = function (item, modal, callback) {
          modalService.showAdvancedConfirmation(
            'Unlock Exam Confirmation',
            'Are you sure to remove lock from this study and assign it to you ?', [ {
              text: 'No',
              onTap: function (e) {

              }
            }, {
              text: 'Yes, Unlock It',
              type: 'button-assertive',
              onTap: function (e) {
                Worklist.unlockExam(item.Id).then(function () {
                  const isTakeOwnership = true;
                  self.assignAndOpen(item, modal, callback, isTakeOwnership);
                });
              }
            } ]);
        };

        self.assignAndOpen = function (item, modal, callback, isTakeOwnership) {
          Worklist.assignToMe(item.Id, isTakeOwnership).then(function (resp) {
            var isAutoStart = self.techpadConfig.settings.HideStartAndEndButtons /*&& (item.Status == self.worklistStatuses.SurveyFinished || item.Status == self.worklistStatuses.ExamWaiting)*/;
            if (resp.data.IsSuccess) {
              if(callback) {
                callback(item);
                return;
              }
              if (isAutoStart) {
                Worklist.updateStatus(item.Id, self.worklistStatuses.ExamInProgress).then(function (resp) {
                  $location.path(worklistConstants.WORKLIST_PAGE_URL + item.Id);
                  $location.search({
                    returnUrl: self.isMyPatients ? worklistConstants.MY_PATIENTS_RETURN_URL : worklistConstants.DEFAULT_RETURN_URL
                  });
                  modal.remove();
                });
              } else {
                $location.path(worklistConstants.WORKLIST_PAGE_URL + item.Id);
                $location.search({
                  returnUrl: self.isMyPatients ? worklistConstants.MY_PATIENTS_RETURN_URL : worklistConstants.DEFAULT_RETURN_URL
                });
                modal.remove();
              }
            } else {
              if (resp.data.IsOwnershipTakingRequired) {
                self.confirmOwnerShipTaken(item, modal, callback);
              } else if (!!resp.data.StudyLockModel) {
                modalService.showAdvancedConfirmation(
                  'Cannot perform exam',
                  'User \'' + resp.data.StudyLockModel.UserName + '\' on workstation \'' + resp.data.StudyLockModel.ClientWorkstation + '\' is currently modifying this study. ' +
                  'You will be able to review current study information, but not change or save the study. ' +
                  'This event was started on ' + moment(resp.data.StudyLockModel.LockedFrom).calendar(), [ {
                    text: 'Unlock this exam',
                    type: 'button-assertive',
                    onTap: function (e) {
                      self.unlockExamPrompt(item, modal, callback);
                    }
                  }, {
                    text: 'View Only',
                    type: 'button-positive',
                    onTap: function (e) {
                      if(!callback){
                        self.openAsViewOnly(item.Id, modal);
                      }
                    }
                  } ]);
              } else {
                modalService.showAlert('This study record not found in database');
              }
            }
          }, function (resp, status) {
            modalService.showErrorMessage(resp.data, resp.status);
          });
        };

        self.addOutsideStudy = function (item, $event) {
          $state.go('root.otherStudyDetails', {worklistId: item.Id});
          $event.preventDefault();
        };

        function getUser() {
          if (!authService.loggedIn) {
            return null;
          }
          let userLoginKey = 'UserLogin';
          let magViewUserName = 'MagViewUserName';
          let magViewRoles = 'magViewRoles';
          return {
            login: localStorage.get(userLoginKey),
            userName: localStorage.get(magViewUserName),
            roles: localStorage.get(magViewRoles)
          };
        }

        self.confirmOwnerShipTaken = function (item, modal, callback) {
          console.log('Owner ship taken required: ', item, item.Technologist, authService.getUserName());

          let errorObject = {};
          errorObject.data = {
            Context: 'Ownership switching requested',
            CurrentWorklistTech: item.Technologist
          };
          errorObject.timestamp = new Date();
          errorObject.hospital = localStorage.getObject('hospital');
          errorObject.user = getUser();
          errorObject.device = localStorage.getObject('MagViewDeviceInfo');

          $http.post(authService.currentMagViewUrl() + '/api/logging/logTechpadErrors', [ errorObject ]).then(function () {
            // all errors send successfully
          }, function () {});

          modalService.showConfirmation(function () {
            const isTakeOwnership = true;
            self.assignAndOpen(item, modal, callback, isTakeOwnership);
          }, 'This exam is owned by technologist ' + (item.Technologist.FirstName + ' ' + item.Technologist.LastName) + '. Are you sure to take over this exam ?');
        };


        self.preparePinNumberForOpeningStudy = function (item) {
          const ssn = item.Ssn;
          const sDate = item.SDate;
          let existingPinObject = _.find($rootScope.pinNumbers, {
            'Ssn': ssn,
            'SDate': sDate
          });
          if (existingPinObject != null) {
            $rootScope.pinNumbers.pop(_.find($rootScope.pinNumbers, {
              'Ssn': ssn,
              'SDate': sDate
            }));
          }
          $rootScope.pinNumbers.push({
            'Ssn': ssn,
            'SDate': sDate,
            'PinNumber': item.PinNumber
          });
        };

        self.sendReadyForExam = async function(item, modal){
          if (!navigator.onLine) {
            return;
          }
          self.readyForExam(item.SurveyQueueId).then(
            result => {
              item.ArrivalStatus = constantStrings.ReadyForExam;
              modal.hide();
            },
            errorResp => {
              modalService.showErrorMessage(errorResp.data.message, errorResp.data.errorId);
            });
        };

        self.readyForExam = async function(surveyQueueId){
          const result = Worklist.readyForExam(surveyQueueId);
          
          return result;
        };

        self.checkForRisRecordIfUltrasound = async function(){
          const confirmationText = commonConstants.DEFAULT_EXAM_REQUIRES_RIS_MESSAGE;          
          const isConfirmed = await modalService.showConfirmationAsync(confirmationText);
          return isConfirmed;
        }

        self.openItem = async function (item, viewOnly, $event, modal) {
          $ionicLoading.show({
            template: "Loading..."
          });

          if (!!item.PinNumber) {
            self.preparePinNumberForOpeningStudy(item);
          }

          if (!viewOnly) {
            let canOpen = true;
            if (item.Status == commonConstants.US_REQUESTED_WORKLIST_STATUS) {
              canOpen = await self.checkForRisRecordIfUltrasound();
            } 

            if (canOpen) {
              const checkResult = await self.checkIfActionCanBePerformed(item.Id, false, true);
              canOpen = checkResult.actionCanBePerformed
            }

            if (canOpen) {              
              const isAssignedToMeResponse = await self.checkIfAssignedToMeAsync(item.Id);
              
              if(isAssignedToMeResponse.errorHappened){
                canOpen = false;
              } else if(!isAssignedToMeResponse.isAssigned && !item.IsFinished){
                canOpen = await self.assignToMeAsync(item.Id, true);
              }
            }

            if(canOpen && self.techpadConfig.settings.HideStartAndEndButtons){
              const isAutoStart = self.techpadConfig.settings.HideStartAndEndButtons;
              if (isAutoStart) {
                try {
                  if (!item.IsFinished){
                    const updateStatusResponse = await Worklist.updateStatus(item.Id, self.worklistStatuses.ExamInProgress);
                  }                    
                } catch (errorResponse) {
                  canOpen = false;
                  $ionicLoading.hide();
                  await modalService.showErrorMessage(errorResponse, commonConstants.DEFAULT_UPDATE_WORKLIST_STATUS_ERROR_MESSAGE); 
                }
              } 
            }

            $event.preventDefault();

            if (canOpen) {
              if (self.isMyPatients) {
                self.openFinishedWorklistItem(item.Id);
              } else {
                self.setLocationConfigForOpenWorklistItem(item.Id, viewOnly);
              }
            }
            
            modal.remove();
          } else {
            self.openAsViewOnly(item.Id, modal);
          }
          $ionicLoading.hide();
        };

        self.openFinishedWorklistItem = function(id) {
          self.setLocationConfigForOpenWorklistItem(id, true, true);
        }

        self.setLocationConfigForOpenWorklistItem = function (id, isViewOnly, isMyPatientMode) {
          $location.path(worklistConstants.WORKLIST_PAGE_URL + id);
          $location.search({
            viewOnly: isViewOnly ? true.toString() : false.toString(),
            returnUrl: self.isMyPatients ? worklistConstants.MY_PATIENTS_RETURN_URL : worklistConstants.DEFAULT_RETURN_URL,
            isMyPatientMode: isMyPatientMode
          });
        }

        self.openAsViewOnly = function (id, modal) {
          self.setLocationConfigForOpenWorklistItem(id, true);

          modal.remove();
        };

        self.formatDate = function (date, convertToLocal) {
          const showDetailedTimeAlways = self.techpadConfig.settings && self.techpadConfig.settings.ShowDetailTimeWithin24HoursDuration;
          
          if (convertToLocal) {
            date = moment.utc(date).local().format();
          }
          // Align the client clock with the server before diffing: the timestamp is server-set,
          // so on a device whose clock trails the server the elapsed time would otherwise go
          // negative right after a status change. Clamp at 0 to guard against residual skew.
          let now = moment().add(serverTimeService.getDiff(), 'ms');
          let minutes = Math.max(0, now.diff(date, 'minutes'));
          let hours = Math.floor(minutes / 60);
          const totalHours = hours;
          minutes = minutes % 60;
          let days = Math.floor(hours / 24);
          hours = hours % 24;
          let totalSeconds = Math.max(0, now.diff(date, 'seconds'));
          let seconds = totalSeconds % 60;

          let resp = '';

          if (days > 0 && !showDetailedTimeAlways) {
            return days + ' days';
          } 
          resp = `${totalHours.toString().length < 2 ? '0':''}${totalHours}:${minutes.toString().length < 2 ? '0':''}${minutes}:${seconds.toString().length < 2 ? '0':''}${seconds}`;
          
          return resp;
        };

        self.formatDateString = dateFormattingHelper.formatDateStringToUSFormat;

        self.addNewFiltersIfAllIsSelected = function () {
          if (!self.techpadConfig.settings.IsTechpadDemoMode) {
            self.filters.ShowAllExams = false;
          }
          if (self.filters.ShowAllTags) {
            self.filters.ShowNoTags = true;
            self.filters.Tags = techpadConfig.settings.Tags.map((tag) => { return tag.Label; });
          }

          if (self.filters.Locations[constantStrings.allOption]) {
            self.locations.forEach(loc => self.filters.Locations[loc.Key] = true)
          }

          if (_.includes(self.filters.ExamTypes, self.constantStrings.allOption)) {
            self.filters.ExamTypes = $rootScope.techpadSettings.GroupExamTypeWorklistFilter ? _.clone(enums.examTypes) : _.clone(self.examTypes);
            self.filters.ExamTypes.push(self.constantStrings.allOption);
          }
        }

        self.loadWorklistFilters = function () {
          return WorklistFilterSettings.getMySettings()
                                       .then(function (settings) {
                                         if (settings) {
                                           self.filters = settings;
                                           self.addNewFiltersIfAllIsSelected();
                                         } else {
                                           self.createDefaultFilter();
                                         }
                                       }, function (error) {
                                         self.createDefaultFilter();
                                       });
        };

        self.createDefaultFilter = async function () {

          let isShowAllAllowed = self.techpadConfig.settings.IsTechpadDemoMode;
          const { IsDashboardMode } = self.techpadConfig.settings;

          let statuses = {};
          if (!IsDashboardMode) {
            var allAllowedStatuses = _.flatten(_.map(self.getAllowedStatusGroups(), function (group) {
              return group.statuses;
            }));

            allAllowedStatuses.forEach(function (s) {
              statuses[s] = true;
            });
          } else {
            // const allowedStatuses = _.map(self.worklistStatuses, status => status);
            const displayStatusesConfigs = await Worklist.getDisplayStatusesConfigs();
            const allowedStatuses = displayStatusesConfigs.data;
            _.forEach(allowedStatuses, function (s) {
              statuses[s.Status] = true;
            });
          }

          let defaultExmaTypesFilter = _.cloneDeep(self.examTypes);
          defaultExmaTypesFilter.push('All');
          self.filters = {
            Locations: {'All':true},
            Statuses: statuses,
            ExamTypes: defaultExmaTypesFilter,
            VisitTypes: _.map(self.visitTypes, 'code'),
            ShowMyExamsOnly: true,
            ShowAllExams: isShowAllAllowed,
            ShowTodayExamsOnly: true,
            NumberOfLastDaysToShow: '7',
            Tags: [],
            ShowAllTags: true,
            ShowNoTags: true
          };
          self.addNewFiltersIfAllIsSelected();
        };

        self.showFilters = function () {
          self.addNewFiltersIfAllIsSelected();
          modalService
            .showWorklistFilters(
              self.filters,
              self.techpadConfig.settings.ShowAppointmentTime,
              self.techpadConfig.settings.ShowStudyDateOnWorklistPage
            )
            .finally(function () {
              self.filterObj.pageIndex = 0;
              self.allItems = [];
              self.loadFiltersAndWorklistData();
            });
        };

        self.refreshFiltersOptions = function () {
          selectedLocations = _.map(self.filters.Locations, function (isTrue, key) {
            if (isTrue)
              return key;
            return null;
          }).filter(function (item) {
            return !!item;
          });

          selectedStatuses = _.map(self.filters.Statuses, function (isTrue, key) {
            if (isTrue)
              return key;
            return null;
          }).filter(function (item) {
            return !!item;
          });

          selectedExamTypes = self.filters.ExamTypes;

          if($rootScope.techpadSettings.GroupExamTypeWorklistFilter){            
            Worklist.getExamTypesInGroups(selectedExamTypes).then(function(resp){
              self.selectedExamTypesInGroups = _.map(resp.data, 'Value');
            });
          }

          selectedExamShortCodeTypes = [];

          _.each(selectedExamTypes, function (item) {
            let index = _.indexOf(enums.examTypes, item);
            if (index > -1)
              selectedExamShortCodeTypes = selectedExamShortCodeTypes.concat(enums.examShortCodeTypes[ index ]);
          });

          selectedVTypes = self.filters.VisitTypes;
          selectedTags = self.filters.Tags;
        };


        self.regenerateFilterObj = function () {
          if (self.filters) {
            self.filterObj = {
              pageIndex: 0,
              search: '',
              filtersSet: self.isMyPatients ? 'MyPatients' : '',
              showAll: self.filters.ShowAllExams,
              showTodayExamsOnly: self.filters.ShowTodayExamsOnly,
              showMyExamsOnly: self.filters.ShowMyExamsOnly,
              showNLastDaysExams: self.filters.ShowNLastDaysExams,
              numberOfLastDaysToShow: self.filters.NumberOfLastDaysToShow,
              ShowAllTags: self.filters.ShowAllTags,
              ShowNoTags: self.filters.ShowNoTags
            };
          }
        };

        // endregion

        self.canChangeStatus = function (item) {
          if (!item.Study || !item.IsLinkedStudy) {
            return true;
          }

          let notAllowedStatuses = [
            constantStrings.worklistStatuses.New.status, constantStrings.worklistStatuses.SurveyStarted.status
          ];

          return notAllowedStatuses.indexOf(item.Status) < 0;
        };

        self.changeStatusPopover = async function (item, event) {
          const checkResult = await self.checkIfActionCanBePerformed(item.Id, false, false);
          if(!checkResult.actionCanBePerformed){
            return;
          }

          var name = (authService.getUserName() || '').toLowerCase();
          var ownerShipTakingRequired = !!item.Technologist && item.Technologist.Email.toLowerCase() !== name;
          if (ownerShipTakingRequired && !checkResult.assignedToMe) {
            self.confirmOwnerShipTaken(item, null, function(item){
              modalService.showWorklistChangeStatus(self, item, event);
            });
          } else {
            modalService.showWorklistChangeStatus(self, item, event);
          }
        };

        self.changeTagsPopover = async function(item, event){
          const checkResult = await self.checkIfActionCanBePerformed(item.Id, false, false);
          if(!checkResult.actionCanBePerformed){
            return;
          }

          var name = (authService.getUserName() || '').toLowerCase();
          var ownerShipTakingRequired = !!item.Technologist && item.Technologist.Email.toLowerCase() !== name;
          if (ownerShipTakingRequired && !checkResult.assignedToMe) {
            self.confirmOwnerShipTaken(item, null, function(item){
              modalService.showWorklistChangeTags(self, item, event);
            });
          } else {
            modalService.showWorklistChangeTags(self, item, event);
          }
        };

        self.toggleTag = async function(item, tag){
          console.log('self.toggleTag', item, tag);
          try {
            $ionicLoading.show({
              template: 'Applying tag change...'
            });

            await Worklist.toggleTag(item.Id, tag.Value);

          } catch (error) {
            modalService.showErrorAlert(modalService.parseError(error) || "Error happened on applying tag change");
            console.error(error);
          } finally {
            $ionicLoading.hide();
          }
        };

        self.changeDashboardItemStatusPopover = async function (item, event) {
          const { Id } = item;
          try {
            $ionicLoading.show({
              template: 'Loading statuses...'
            });
            const changeStatusesConfigs = await Worklist.getChangeStatusesConfigs(Id);
            self.allowedWorklistChangeStatuses = changeStatusesConfigs.data;
            if (!self.allowedWorklistChangeStatuses.length) {
              throw "No statuses are available for the worklist";
            }
          } catch (error) {
            modalService.showAlert((error && error.data && error.data.Message) || (error && error.Message) || error || "Error happened on opening change status dropdown");
            console.error(error);
            return;
          } finally {
            $ionicLoading.hide();
          }

          modalService.showDashboardItemChangeStatus(self, item, event);
        };  

        self.changeStatus = async function (item, status) {
          const { Id } = item;
          
          $ionicLoading.show({
            template: 'Changing status...'
          });
          if (item.Status == "UltrasoundRequested") {
            modalService.showAlert('Status change is not available for Ultrasound Request exam.');
            return;
          }
          try {
            await Worklist.ownWorklist(Id);
            await Worklist.updateStatus(Id, status);
            item.Status = status;
          } catch (error) {
            modalService.showAlert((error && error.data && error.data.Message) || (error && error.Message) || error || "Error happened on changing status");
          } finally {
            $ionicLoading.hide();
          }
        };

        self.selectResourceForWorklist = function(worklistItem, resource, modal, isResourcesOnly){          
          if(worklistItem.selectedResource === resource.label){
            worklistItem.selectedResource = '';
          }else{
            worklistItem.selectedResource = resource.label;
          }
          if(isResourcesOnly){
            self.applyResource(worklistItem);
            modal.remove();
          }
        };

        self.isResourceSelected = function(worklistItem, resource){
          return worklistItem.selectedResource === resource.label;
        }

        self.changeListMessageAndResourcePopover = async function (item, event, isResourcesOnly) {
          if (self.ListMessageReadOnly || item.IsMissingPatient) {
            return;
          }
          event.stopPropagation();
          $ionicLoading.show({
            template: 'Loading available resources...'
          });
          try {
            const result = await Worklist.getAvailableResources(item.Id);
            const availableResources = result && result.data || [];
            const availableResourcesModels = availableResources.map(resource => {
              return { label: resource.Label };
            });
            const message = authService.isRadiologist() ? item.RadListMessage : item.ListMessage;
            modalService.showWorklistChangeListMessageAndResource(self, item, event, !!message, availableResourcesModels, isResourcesOnly);
          } catch (error) {
            console.error(error);
          } finally {
            $ionicLoading.hide();
          }
        };

        self.applyResource = async (worklist, shouldNotShowLoadingScreen) => {
          await Worklist.updateResource(worklist.Id, worklist.selectedResource);
          if (worklist) {
            worklist.Resource = worklist.selectedResource;
          } else {
            throw "worklist not found";
          }
        };

        self.onDashboardWindowSave = async (worklist, modal) => {
          try {

            $ionicLoading.show({ template: 'Saving...' });

            await self.applyListMessage(worklist);

            modal.hide();

          } catch (error) {
            modalService.showErrorAlert(modalService.parseError(error) || "Error happened on applying new list messages");
            console.error(error);
          } finally {
            $ionicLoading.hide();
          }
        };

        self.applyListMessage = async (worklist) => {

          await Worklist.applyListMessage(worklist.Id, worklist.newListMessage);

          if (worklist) {
            worklist.ListMessage = worklist.newListMessage;
          } else {
            throw Error("Worklist not found");
          }
        };

        self.applyListMessageAndResource = async (worklist, modal) => {
          const shouldNotShowLoadingScreen = true;
          try {
            $ionicLoading.show({
              template: 'Applying list message and resource...'
            });
            await self.applyListMessage(worklist, shouldNotShowLoadingScreen);
            await self.applyResource(worklist, shouldNotShowLoadingScreen);
            modal.remove();
          } catch (error) {
            modalService.showErrorAlert(modalService.parseError(error) || "Error happened on applying new list message and resource values");
            console.error(error);
          } finally {
            $ionicLoading.hide();
          }
        };

        self.changeResourcePopover = function (item, event) {
          if (!self.techpadConfig.settings.IsDashboardMode|| item.IsMissingPatient) {
            return;
          }
          event.stopPropagation();
          modalService.showWorklistChangeResource(self, item, event, !!item.Resource);
        };

        self.changeListMessage = async (worklistItem, listMessage) => {
          const currentListMessage = worklistItem.ListMessage;
          worklistItem.ListMessage = listMessage;

          try {
            const response = await Worklist.updateListMessage(worklistItem.Id, listMessage);

            if (!response.data.Success) {
              throw new Error('Error while updating list message');
            }
          } catch (error) {
            worklistItem.ListMessage = currentListMessage + ' - Updated failed';
          }
        };

        self.changeResource = async (worklistItem, resource) => {
          const currentResource = worklistItem.Resource;
          worklistItem.Resource = resource;

          try {
            const response = await Worklist.updateResource(worklistItem.Id, resource);

            if (!response.data.Success) {
              throw new Error('Error while updating ' + self.techpadConfig.settings.ResourcesTitle);
            }
          } catch (error) {
            worklistItem.Resource = currentResource + ' - Update failed';
          }
        };

        self.showExamWindow = async function (item) {
          try {
            $ionicLoading.show({
              template: commonConstants.DEFAULT_LOADER_MESSAGE
            });
            if(item.IsMissingPatient){
              return;
            }
            if (item.Status === commonConstants.US_REQUESTED_WORKLIST_STATUS || item.Status === commonConstants.RIS_WAITING_WORKLIST_STATUS) {
              modalService.showRequestedUltrasoundWindow(self, item);
            } else {
              self.shouldShowReadForExamMenu = item.ArrivalStatus == commonConstants.PATIENT_ARRIVED_IMHERE_WORKLIST_STATUS;
              modalService.showExamWindow(self, item);
            }
          } 
          catch (error) {
            console.error(error);
            await modalService.showAlertAsync(modalService.parseError(error));
          } 
          finally {
            $ionicLoading.hide();
          }
        };


        self.showDashboardWindow = async function (item) {
          self.ShouldShowMessageModal = true;
          modalService.showDashboardWindow(self, item);
        };


        self.isExamMine = function (item) {
          return item.Technologist && item.Technologist.Email.toLowerCase() == (authService.getUserName() || '').toLowerCase();
        };

        self.unassignWorklist = _.debounce(function (item, modal) {
          modalService.showConfirmation(() => {
            Worklist.unassignFromMe(item.Id).then((resp) => {
              modal.remove();
              self.hardRefresh();
            }, (error) => {
              console.log(error);
            });
          }, 'Are you sure you want to un-assign this patient from yourself?');
        }, 500);

        self.isShowGeneratePinNumber = function (item) {
          if ((item.Status == self.statuses[ 0 ] || item.Status == self.statuses[ 1 ]) && item.ArrivalStatus!="PatientArrived") {
            return true;
          }
          return false;
        };

        self.generatePinNumber = function (item) {
          if (self.isShowGeneratePinNumber) {
            let ownerShipTakingRequired = !!item.Technologist && item.Technologist.Email.toLowerCase() !== (authService.getUserName() || '').toLowerCase();
            if(ownerShipTakingRequired){
              self.confirmOwnerShipTaken(item, null, function(item){
                $ionicLoading.show({
                  template: 'Loading...'
                });

                Study.generatePinNumber(item.Ssn, item.SDate).then(function (resp) {
                  Study.startSurvey(item.Ssn, item.SDate, resp.data, true).then(function () {
                    item.PinNumber = resp.data;
                    self.preparePinNumberForOpeningStudy(item);

                    $ionicLoading.hide();
                  });
                });
              });
            } else {
              $ionicLoading.show({
                template: 'Loading...'
              });

              Study.generatePinNumber(item.Ssn, item.SDate).then(function (resp) {                
                Study.startSurvey(item.Ssn, item.SDate, resp.data, true).then(function () {
                  item.PinNumber = resp.data;
                  self.preparePinNumberForOpeningStudy(item);

                  $ionicLoading.hide();
                });
              });
            }
          }
        };

        self.processCreatedRIS = function (item, viewOnly, $event) {
          Worklist.processCreatedRIS(item.Id).then(function () {
            self.hardRefresh();
          });
        };

        self.rejectUltrasound = function (item, viewOnly, $event) {
          self._deleteWorklistItem(item);
        };

        self.showExamLockedAndAskToRemoveLocks = async function(currentUser){
          const confirmationText = 
            `This study is currently being performed by "${currentUser.UserName}". If you click proceed, you may overwrite their changes. Would you like to proceed?`;
          const params = {
            title: commonConstants.EXAM_LOCKED_POPUP_HEADER,
            okText: commonConstants.STUDY_LOCKED_POPUP_CONFIRM_BUTTON,
            okType: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS
          };
          const isConfirmedToRemoveLocks = await modalService.showConfirmationAsync(confirmationText, params);
          return isConfirmedToRemoveLocks;
        }

        self.showSameDayStudiesLockedWarning = async function(currentUser){
          const confirmationText = `This patient has multiple open studies also being performed by "${currentUser.UserName}". If you proceed, you may overwrite their changes. Would you like to proceed?`;
          const params = {
            title: commonConstants.SAME_DAY_STUDIES_LOCKED_POPUP_HEADER,
            okText: commonConstants.CONTINUE_LABEL,
            okType: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS
          };
          const isConfirmedToRemoveLocks = await modalService.showConfirmationAsync(confirmationText, params);
          return isConfirmedToRemoveLocks;
        }

        self.unlockExamConfirmation = async function(){
          const confirmationText = commonConstants.UNLOCK_STUDY_CONFIRMATION_MESSAGE;
          const params = {
            title: commonConstants.UNLOCKED_EXAM_POPUP_HEADER,
            okText: commonConstants.UNLOCKED_EXAM_POPUP_CONFIRM_BUTTON,
            okType: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS
          };
          const isConfirmed = await modalService.showConfirmationAsync(confirmationText, params);
          return isConfirmed;
        }

        self.unlockExamAsync = async function (worklistId) {
          let isErrorHappened = false;
          try {
            const unlockExamResponse = await Worklist.unlockExam(worklistId);
          } catch (errorResponse) {
            isErrorHappened = true;
            await modalService.showErrorMessage(errorResponse, commonConstants.DEFAULT_UNLOCK_STUDY_ERROR_MESSAGE); 
          }

          return !isErrorHappened;
        };

        self.assignToMeAsync = async function (worklistId, isLockStudy) {
          let isErrorHappened = false;
          const isTakeOwnership = true;

          try {
            const assignToMeResponse = await Worklist.assignToMe(worklistId, isTakeOwnership, !isLockStudy);
            if (!assignToMeResponse.data.IsSuccess) {
              isErrorHappened = true;
              $ionicLoading.hide();
              let errorMessage = commonConstants.DEFAULT_STUDY_NOT_FOUND_IN_DB_ERROR_MESSAGE;
              await modalService.showAlertAsync(errorMessage);                
            }
          } catch (errorResponse) {
            isErrorHappened = true;
            $ionicLoading.hide();
            await modalService.showErrorMessage(errorResponse, commonConstants.DEFAULT_ASSIGN_STUDY_TO_YOU_ERROR_MESSAGE);               
          }

          return !isErrorHappened;
        };

        self.checkIfAssignedToMeAsync = async function(worklistId){
          let response = {
            errorHappened: false,
            isAssigned: false
          };

          try {
            const isAssignedToMeResponse = await Worklist.isAssignedToMe(worklistId);
            response.isAssigned = isAssignedToMeResponse.data.IsAssignedToMe;
          } catch (errorResponse) {
            response.errorHappened = true;
            $ionicLoading.hide();
            await modalService.showErrorMessage(errorResponse, commonConstants.DEFAULT_CHECK_IF_ASSIGNED_TO_ME_ERROR_MESSAGE);
          }

          return response;
        };

        self.checkIfActionCanBePerformed = async function(worklistId, hideAlert, isLockStudy){
          const response = {
            actionCanBePerformed: true,
            assignedToMe: false
          };
          
          const studyLockedResponse = await Worklist.checkStudyLock(worklistId);
          if(studyLockedResponse.data.IsLock){
            response.actionCanBePerformed = false;
            self.lockedByUserName = studyLockedResponse.data.CurrentUser.UserName;
            if(!hideAlert){
              $ionicLoading.hide();
              const isConfirmedToRemoveLocks = await self.showExamLockedAndAskToRemoveLocks(studyLockedResponse.data.CurrentUser);
              if(isConfirmedToRemoveLocks){
                const isConfirmed = await self.unlockExamConfirmation();
                if(isConfirmed){
                  response.actionCanBePerformed = await self.unlockExamAsync(worklistId);
                  if(response.actionCanBePerformed){
                    response.actionCanBePerformed = await self.assignToMeAsync(worklistId, isLockStudy);
                    response.assignedToMe = true;
                  }
                }
              }
            }
          }
          if(!studyLockedResponse.data.IsLock && $rootScope.techpadSettings && $rootScope.techpadSettings.ShowMyriadButton){
            const sameDayStudiesLockResponse = await Worklist.checkSameDayStudiesLock(worklistId);
            if(sameDayStudiesLockResponse.data.IsLock){
              response.actionCanBePerformed = false;
              if(!hideAlert){
                $ionicLoading.hide();
                const isConfirmedToContinue = await self.showSameDayStudiesLockedWarning(sameDayStudiesLockResponse.data.CurrentUser);
                if(isConfirmedToContinue){
                  response.actionCanBePerformed = true;
                  await Worklist.overwriteAudit(worklistId);
                }
              }
            }
          }
          return response;
        };

        self.deleteItem = async function (item, modal) {
          const checkResult = await self.checkIfActionCanBePerformed(item.Id, false, false);
          if(!checkResult.actionCanBePerformed){
            return;
          }

          var name = (authService.getUserName() || '').toLowerCase();
          var ownerShipTakingRequired = !!item.Technologist && item.Technologist.Email.toLowerCase() !== name;
          if (ownerShipTakingRequired && !checkResult.assignedToMe) {
            modalService.showConfirmation(() => {
              self._deleteWorklistItem(item);
            }, "This exam is owned by technologist " + (item.Technologist.FirstName + ' ' + item.Technologist.LastName) + ". Are you sure to remove this exam ?");
            return;
          }
          modalService.showConfirmation(() => {
            self._deleteWorklistItem(item);
          }, "Are you sure you want to delete worklist item of \'" + item.Type + "\' Study for patient " + item.LastName + ", " + item.FirstName + "?");
        };

        self._deleteWorklistItem = function (item) {
          Worklist.remove(item.Id).then(function () {
            self.hardRefresh();
          });
        };

        self.skipSurvey = function (ssn, sDate) {
          Study.skipSurveyAndStartExam(ssn, sDate).then(function (resp) {
            self.hardRefresh();
          });
        };

        self.openLinkedStudies = async function (item) {
          const checkResult = await self.checkIfActionCanBePerformed(item.Id, false, false);
          if(!checkResult.actionCanBePerformed){
            return;
          }
          $ionicLoading.show({
            template: 'Loading...'
          });
  
          const modelForLinkStudies = new linkStudiesViewModel(item);

          modelForLinkStudies.isIOSDevice = self.isIOSDevice;

          await modelForLinkStudies.initializeLinkedStudies();

          modalService.showLinkedStudiesWindow(modelForLinkStudies)
                      .then(function () {
                        self.hardRefresh();
                      });
                        
          $ionicLoading.hide();
        };

        $scope.eventHandlers = {
          itemUpdated: self.itemUpdated.bind(self),
          itemCreated: self.itemUpdated.bind(self),
          itemRemoved: self.itemRemoved.bind(self)
        };

        Worklist.onItemUpdated($scope.eventHandlers.itemUpdated);
        Worklist.onItemCreated($scope.eventHandlers.itemUpdated);
        
        Worklist.onItemRemovedStatusChanged($scope.eventHandlers.itemRemoved);

        self.deviceEvents = [
          eventsMgr.on('device:online', function () {
            self.hardRefresh();
          }),
          eventsMgr.on('device:resume', function () {
            self.hardRefresh();
          })
        ];

        self.destroy = function () {
          _.each(self.deviceEvents, function (event) {
            event.unsubscribe();
          });

          techpadConfigChangeRegistration.unsubscribe();
          pubsubService.off('CHAT_LOGIN_START');
          pubsubService.off('CHAT_LOGIN_DONE');
        };

        self.loadFiltersAndWorklistData = function () {
          self.initialized = true;
          return dataRetrieverService.cachedProxy('worklist-locations', 30, Worklist.getLocations).then(function (resp) {
            self.locations = resp.data;
            self.locations.unshift({
              Key: 'All',
              Value: 'All'
            });
            return self.loadWorklistFilters().then(function () {
              self.refreshFiltersOptions();
              self.regenerateFilterObj();
              return self.refresh();
            });
          }, function () {
            self.locations = [];
          });
        };

        self.isCountingDisabled = function(status){
          return self.techpadConfig.settings.WorklistStatusesConfigs.some(function(config){
            return config.Status == status && config.IsCountingDisabled;
          });
        }

        self.loadFiltersAndWorklistData();
      };

      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/worklist.js